// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

import ViewUI from 'view-design';
import 'view-design/dist/styles/iview.css';

import BaiduMap from 'vue-baidu-map'
Vue.prototype.$BaseUrl = "http://hsqxj.hbxfzzb.com:8899"
Vue.use(BaiduMap, {
  ak: 'mqWvfPyel8kQAfV5WUC0AGg2Nkft6WTN'  //这个地方是官方提供的ak密钥
})

Vue.use(router);
Vue.use(ViewUI);


/**
 * 路由守卫全局注册
 * @param {*} err 
 */
 router.beforeEach((to, from, next) => {

  // /**
  //  * 匹配路由是否存在  不存在则进入登录页面
  //  * to.matched.length
  //  */
  console.log("matched",to.matched.length)
  if(to.matched.length == 0){
        ViewUI.Message.error("非法访问");
        sessionStorage.removeItem("user")
        next("/")
  }else{
    
 /**
   * 判断是否登录成功
   */
  if(sessionStorage.getItem("user")){
 
    if(to.path == "/"){
 
      next()
    }else{

      next()
    }
 }else{
   if(to.path == "/"){
     next()
   }else{
     next("/")
   }
 }    
  }
 

  // console.log("jumpPath: ",to.matched.length)
  // next()
})



console.log = function () {}
// 屏蔽错误信息
Vue.config.errorHandler = (err) => {
};
// 屏蔽警告信息
Vue.config.warnHandler = (message) => {
};

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js